export const ICON_DIMENSIONS = {
  STRIPE: {
    width: 70,
    height: 36,
  },
  BANK_NOTE: {
    width: 18,
    height: 18,
  },
} as const;

export const STATUS_CHIP = {
  width: 84,
  height: 25,
  borderRadius: 8,
} as const;
